<template>
  <v-card
    flat
    color="transparent"
    width="100%"
    height="30"
    elevation="0"
    class="container-add-clip"
    :style="firstPanelisSmall ? 'padding: 0 0 0 5px' : 'padding: 0 10px'"
  >
    <div class="expandButton" :style="expandBtnCss" @click="setClipType('record')">
      <span class="add">
        <span class="material-icons-round" :style="firstPanelisSmall ? '' : 'margin-right: 5px'" translate="no">
          add
        </span>
        <span v-if="!firstPanelisSmall" class="add-span">Add Clip</span>
      </span>
      <span class="record">
        <span class="material-icons-round" :style="firstPanelisSmall ? '' : 'margin-right: 5px'" translate="no">
          radio_button_checked
        </span>
        <span v-if="!firstPanelisSmall" class="record-span">Record</span>
      </span>
    </div>

    <div :class="firstPanelisSmall ? 'btn-outdiv small-panel upload' : 'btn-outdiv upload'">
      <div class="btn-innerdiv" @click="setClipType('upload')">
        <span class="material-icons-round" :style="firstPanelisSmall ? '' : 'margin-right: 5px'" translate="no">
          upload
        </span>
        <span v-if="!firstPanelisSmall">Upload</span>
      </div>
    </div>
    <div :class="firstPanelisSmall ? 'btn-outdiv small-panel text' : 'btn-outdiv text'">
      <div class="btn-innerdiv" @click="setClipType('text')">
        <span class="material-icons-round" :style="firstPanelisSmall ? '' : 'margin-right: 5px'" translate="no">
          title
        </span>
        <span v-if="!firstPanelisSmall">Text</span>
      </div>
    </div>
    <div :class="firstPanelisSmall ? 'btn-outdiv small-panel embed' : 'btn-outdiv embed'">
      <div class="btn-innerdiv" @click="setClipType('embed')">
        <span class="material-icons-round" :style="firstPanelisSmall ? '' : 'margin-right: 5px'" translate="no">
          code
        </span>
        <span v-if="!firstPanelisSmall">Embed</span>
      </div>
    </div>
    <div :class="firstPanelisSmall ? 'btn-outdiv small-panel poll' : 'btn-outdiv poll'">
      <div class="btn-innerdiv" @click="setClipType('poll')">
        <span class="material-icons-round" :style="firstPanelisSmall ? '' : 'margin-right: 5px'" translate="no">
          how_to_vote
        </span>
        <span v-if="!firstPanelisSmall">Poll</span>
      </div>
    </div>
    <div :class="firstPanelisSmall ? 'btn-outdiv small-panel response' : 'btn-outdiv response'">
      <div class="btn-innerdiv" @click="requestResponse">
        <span class="material-icons-round" :style="firstPanelisSmall ? '' : 'margin-right: 5px'" translate="no">
          notification_important
        </span>
        <span v-if="!firstPanelisSmall">Request</span>
      </div>
    </div>
    <!-- <div class="btn-outdiv follow">
      <div class="btn-innerdiv">
        <i class="mdi mdi-handshake-outline"></i>
        <span>Follow</span>
      </div>
    </div> -->
    <request-response-dialog
      v-if="requestVisible"
      @close="requestVisible = false"
      @finish="finishRequestDialog"
      :requestResponseVisible.sync="requestVisible"
    ></request-response-dialog>
    <require-upgrade-dialog
      v-if="upgradeVisible"
      @close="upgradeVisible = false"
      :requireUpgradeVisible.sync="upgradeVisible"
      :branch.sync="type"
    ></require-upgrade-dialog>
    <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
  </v-card>
</template>

<script>
import { isMobile } from '@/common/lib/strLib'
import Toast from '@/views/meeting/component/Toast'
import { mapGetters } from 'vuex'
import RequestResponseDialog from '@/views/modal/RequestResponseDialog'
import RequireUpgradeDialog from '@/views/modal/RequireUpgradeDialog'
import GuestIn from '@/views/modal/GuestIn'

export default {
  name: 'AddClipCard',
  components: { RequestResponseDialog, RequireUpgradeDialog, GuestIn },
  props: { firstPanelisSmall: Boolean },
  data() {
    return {
      hovered: null,
      key: 'hoverd',
      requestVisible: false,
      upgradeVisible: false,
      guestInVisible: false,
      guestInActionType: '',
      img: {
        embed: require('@/assets/img/embed.png'),
        embedWhite: require('@/assets/img/embed-white.png'),
      },
      type: '',
    }
  },
  mounted() {
    let isActive = false
    const container = document.getElementsByClassName('container-add-clip')
    const outdiv = document.getElementsByClassName('btn-outdiv')

    // container[0].addEventListener('mouseover', addActive, false)
    // container[0].addEventListener('mouseleave', removeActive, false)

    for (let i = 0; i < container.length; i++) {
      container[i].addEventListener('mouseover', addActive, false)
      container[i].addEventListener('mouseleave', removeActive, false)
    }

    for (let i = 0; i < outdiv.length; i++) {
      outdiv[i].addEventListener('mouseover', addActive, false)
      outdiv[i].addEventListener('mouseleave', removeActive, false)
    }

    function addActive() {
      if (!isActive) {
        for (let i = 0; i < container.length; i++) {
          container[i].classList.add('isActive')
        }
        // container[0].classList.add('isActive')
        isActive = !isActive
      }
    }

    function removeActive() {
      if (isActive) {
        for (let i = 0; i < container.length; i++) {
          container[i].classList.remove('isActive')
        }
        isActive = !isActive
      }
    }
    document.addEventListener('keydown', this.keyEvent)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyEvent)
  },
  methods: {
    keyEvent(e) {
      if (
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLInputElement) &&
        e.target.contentEditable !== 'true'
      ) {
        // R : 녹화 시작 (비디오)
        if (!e.ctrlKey && !e.metaKey && e.keyCode === 82) {
          this.setClipType('record')
          e.preventDefault()
        }
      }
    },
    closeGuestIn() {
      this.guestInVisible = false
      if (this.userInfo && this.userInfo !== null) {
        this.setClipType(this.guestInActionType)
      }
    },
    setClipType(type) {
      if ((type === 'record' || type === 'upload') && this.uploadVideoInfo && this.uploadVideoInfo['clip']) {
        // notify(this, 'Error', this.$t('clipUploadingError'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('clipUploadingError'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        return
      }
      if (!this.userInfo || this.userInfo === null) {
        this.$store.dispatch('setSignInRedirectUrl', location.pathname)
        this.guestInActionType = type
        this.guestInVisible = true
        // this.$router.push({ name: 'SignIn' })
      } else {
        this.type = type
        if (!this.checkAvailableClip) {
          this.upgradeVisible = true
          return
        }
        // Free Type 일 경우 video upload 30개 이상인지 체크
        if (this.checkAvailableClip) {
          this.$store.dispatch('setIsRequestVideoType', type)
        }
      }
    },
    requestResponse() {
      if (!this.userInfo || this.userInfo === null) {
        this.$store.dispatch('setSignInRedirectUrl', location.pathname)
        // this.$router.push({ name: 'SignIn' })
        this.guestInVisible = true
      } else if (this.currentMt.isPublic) {
        if (this.currentMt.isEnded) {
          // notify(this, 'Error', this.$t('notiEndedMeeting'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('notiEndedMeeting'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
        // Free Type 일 경우 video upload 30개 이상인지 체크
        else if (this.checkAvailableClip) this.requestVisible = true
        // 업그레이드 팝업 호출
        else this.upgradeVisible = true
      } else {
        let isJoinedWorkspaceFist = false

        if (this.userWsList && this.userWsList !== null && this.selectedWsInfo && this.selectedWsInfo !== null) {
          let workspace = this.userWsList.find((workspace) => workspace.wsId === this.selectedWsInfo.wsId)
          if (!workspace || workspace === null) isJoinedWorkspaceFist = true
        } else isJoinedWorkspaceFist = true
        if (this.followUpExsitContents !== undefined && this.followUpExsitContents !== null) {
          // notify(this, 'Error', this.followUpExsitContents, 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.followUpExsitContents,
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else if (isJoinedWorkspaceFist) {
          // notify(this, 'Error', this.$t('joinTheWorkspaceFirstMsg'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('joinTheWorkspaceFirstMsg'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        } else {
          if (this.currentMt.isEnded) {
            // notify(this, 'Error', this.$t('notiEndedMeeting'), 'error')
            const content = {
              component: Toast,
              props: {
                msg: this.$t('notiEndedMeeting'),
                // submsg: '',
              },
            }
            this.$toast.error(content)
          }
          // Free Type 일 경우 video upload 30개 이상인지 체크
          else if (this.checkAvailableClip) this.requestVisible = true
          // 업그레이드 팝업 호출
          else this.upgradeVisible = true
        }
      }
    },
    finishRequestDialog() {
      this.requestVisible = false
    },
  },
  computed: {
    ...mapGetters([
      'uploadVideoInfo',
      'totalSectionList',
      'userInfo',
      'currentMt',
      'userWsList',
      'selectedWsInfo',
      'wsClipCnt',
    ]),
    computedWsClipCnt() {
      return this.wsClipCnt ?? {}
    },
    checkAvailableClip() {
      let isAvailableClip = true
      if (
        (this.userInfo &&
          (!this.computedWsClipCnt['planType'] || this.computedWsClipCnt['planType'] !== 'Plus') &&
          this.computedWsClipCnt['wsClipDuration'] >= this.computedWsClipCnt['freePlanWsClipDurationLimit']) ||
        (this.type == 'upload' && this.computedWsClipCnt['planType'] !== 'Plus')
      ) {
        isAvailableClip = false
      }
      return isAvailableClip
    },
    sectionList() {
      if (this.totalSectionList !== undefined && this.totalSectionList !== null && this.totalSectionList.length > 0) {
        return this.totalSectionList
      }
      return []
    },
    isMobile() {
      return isMobile()
      // return true
    },
    expandBtnCss() {
      return {
        '--outline-color': this.$store.getters.isLastClip ? '#ff575f' : '#ccc',
      }
    },
  },
}
</script>

<style scoped>
.container-add-clip {
  position: relative;
  display: inline-block;
  border-radius: 5px;
  z-index: 8;
  /* min-width: 150px; */
}
@media (max-width: 959px) {
  .container-add-clip {
    display: none;
  }
}
.mdi::before {
  color: #ff575f;
}
.record .mdi::before {
  color: #ff575f;
}
.btn-innerdiv .mdi::before {
  position: relative;
  font-size: 25px;
  color: #ddd;
}
.btn-innerdiv span {
  position: relative;
}
.container-add-clip .expandButton {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  width: 100%;
  height: 40px;
  position: relative;
  background: #d4424a;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s;
  font-weight: 500;
  color: #fff;
  font-size: 14px;
  letter-spacing: -0.2px;
  cursor: pointer;
  padding: 0 15px;
}
.container-add-clip.isActive .expandButton {
  background: #161d21;
}

.container-add-clip .btn-outdiv.text,
.container-add-clip .btn-outdiv.upload,
.container-add-clip .btn-outdiv.embed,
.container-add-clip .btn-outdiv.follow,
.container-add-clip .btn-outdiv.poll,
.container-add-clip .btn-outdiv.response {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  background: rgb(29, 41, 47);
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.45s;
  font-weight: 500;
  color: #ccc;
  font-size: 13px;
  letter-spacing: -0.2px;
  cursor: pointer;
  z-index: 1;
  padding: 0 10px;
}
.small-panel {
  padding: 0 0 0 5px !important;
}
.container-add-clip .btn-innerdiv {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 40px;
  background: #161d21;
  border-radius: 5px;
  position: relative;
  padding: 0 15px;
}
.container-add-clip .btn-innerdiv:hover {
  color: #fff;
}
.container-add-clip .btn-innerdiv:hover .mdi::before {
  color: #fff;
}
.container-add-clip .expandButton {
  z-index: 10;
}
.container-add-clip .record:hover span {
  color: #fff;
}
.container-add-clip .expandButton:before {
  content: '';
  display: block;
  width: 100%;
  height: 50px;
  position: absolute;
  border-radius: 5px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  z-index: -1;
}
.container-add-clip .text,
.container-add-clip .upload,
.container-add-clip .embed,
.container-add-clip .poll,
.container-add-clip .follow,
.container-add-clip .response {
  width: 100%;
  height: 30px;
  background: #0f2129;
}
.container-add-clip .text {
  transition-delay: 0s;
}
.container-add-clip .upload {
  transition-delay: 0s;
}
.container-add-clip .embed {
  transition-delay: 0s;
}
.container-add-clip .poll {
  transition-delay: 0s;
}
.container-add-clip .follow {
  transition-delay: 0s;
}
.container-add-clip.isActive .expandButton {
  transform: translate(-50%, -50%);
}
.container-add-clip .expandButton:hover {
  color: #fff;
}
.container-add-clip.isActive .expandButton:hover:before {
  animation-duration: 1.5s;
  animation-name: beat;
  animation-iteration-count: infinite;
}
@keyframes beat {
  0% {
    width: 100%;
    height: 100%;
  }
  25% {
    width: 100%;
    height: 100%;
  }
  30% {
    width: 110%;
    height: 120%;
  }
  50% {
    width: 105%;
    height: 110%;
  }
  70% {
    width: 110%;
    height: 120%;
  }
  90% {
    width: 100%;
    height: 100%;
  }
  100% {
    width: 100%;
    height: 100%;
  }
}
.container-add-clip.isActive .text {
  top: 65px;
  left: 50%;
  transition-delay: 0.05s;
}
.container-add-clip.isActive .upload {
  top: 115px;
  left: 50%;
  transition-delay: 0.1s;
}
.container-add-clip.isActive .embed {
  top: 165px;
  left: 50%;
  transition-delay: 0.15s;
}
.container-add-clip.isActive .poll {
  top: 215px;
  left: 50%;
  transition-delay: 0.15s;
}
.container-add-clip.isActive .response {
  top: 265px;
  left: 50%;
  transition-delay: 0.2s;
}
.container-add-clip .add {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  opacity: 1;
}
.container-add-clip .record {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  opacity: 0;
  transition: all 0.3s;
  color: #ddd;
}
.container-add-clip.isActive .add {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  opacity: 0;
  transition: all 0.3s;
}
.container-add-clip.isActive .record {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  opacity: 1;
}
.material-icons-round {
  font-size: 18px;
}
</style>
